import { CKButton } from '@clearkit/react';
import CopyText from 'react-copy-text';

import InfoIconBlue from '~/images/onboarding/icon-info-blue.svg';

import styles from './styles';

const Integration = ({
  classes,
  snippet,
  integrationText,
  copyText,
  textAreaHeight,
  copyButtonText = 'Copy code',
}) => {
  const [textToCopy, setSnippet] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => {
      setSnippet('');
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div>
      <div className={classes.integrationCopy}>{integrationText}</div>

      <div className={classes.snippetContainer}>
        <textarea
          readOnly
          style={{ height: textAreaHeight }}
          value={snippet}
          onClick={(event) => {
            event.target.select();
          }}
          className={classes.snippet}
        />
        <div className={classes.copyContainer}>
          <div className={classes.iconTextContainer}>
            <InfoIconBlue />
            <span className={classes.copyText}>{copyText}</span>
          </div>

          <div>
            <CKButton onClick={() => setSnippet(snippet)} variant="simple">
              {isCopied ? 'Copy success!' : copyButtonText}
            </CKButton>
            <CopyText text={textToCopy} onCopied={handleCopy} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(Integration);
